export const RDG_ROW_NUMBER_COLUMN_KEY = "__rdg-row-number";

export const GRID_COLUMN_TO_SELECTION_KEY = {
    aircraftReg: "aircraft_reg",
    flightDate: "flight_date",
    dayOfWeek: "day_of_week",
    flightNumber: "flight_number",
    departureAirport: "departure_airport",
    arrivalAirport: "arrival_airport",
    flightRouteId: "flight_route_id",
    stdTime: "std",
    staTime: "sta",
    blockTime: "block_time_minutes",
    groundTime: "ground_time_minutes",
    stcType: "stc_type",
    remarks: "remarks",
    constraintStatus: "constraint_status",
    isFixed: "is_fixed",
    changeStatus: "change_status",
};

export const SELECTION_COLUMN_LABELS = {
    aircraft_reg: "飞机注册号",
    flight_date: "日期",
    day_of_week: "星期",
    flight_number: "航班号",
    departure_airport: "出发机场",
    arrival_airport: "到达机场",
    flight_route_id: "航路",
    std: "STD",
    sta: "STA",
    block_time_minutes: "Block Hour",
    ground_time_minutes: "Ground Time",
    stc_type: "航班性质",
    remarks: "备注",
    constraint_status: "约束与提示",
    is_fixed: "锁定状态",
    change_status: "变更状态",
};

export const BATCH_EDITABLE_COLUMNS = new Set(["aircraft_reg", "flight_number", "remarks", "stc_type", "departure_airport", "arrival_airport"]);

const NON_SELECTABLE_COLUMN_KEYS = new Set([RDG_ROW_NUMBER_COLUMN_KEY, "actions"]);

export function getSelectionColumnKey(columnKey) {
    return GRID_COLUMN_TO_SELECTION_KEY[columnKey] || columnKey;
}

export function getSelectionColumnLabel(columnKey) {
    return SELECTION_COLUMN_LABELS[columnKey] || columnKey;
}

export function makeCellKey(flightId, columnKey) {
    return `${flightId}:${columnKey}`;
}

export function parseCellKey(cellKey) {
    const separatorIndex = String(cellKey || "").indexOf(":");
    if (separatorIndex <= 0) {
        return null;
    }

    return {
        flightId: String(cellKey).slice(0, separatorIndex),
        columnKey: String(cellKey).slice(separatorIndex + 1),
    };
}

export function getFlightIdFromRow(row) {
    return row?.rawFlight?.id ?? row?.id ?? null;
}

export function isSelectableGridColumn(column) {
    return Boolean(column?.key) && !NON_SELECTABLE_COLUMN_KEYS.has(column.key);
}

export function getCellKey(row, column) {
    if (row?._rowType !== "flight" || !isSelectableGridColumn(column)) {
        return null;
    }

    const flightId = getFlightIdFromRow(row);
    if (flightId == null) {
        return null;
    }

    return makeCellKey(String(flightId), getSelectionColumnKey(column.key));
}

export function getCellsInRectangle(rows, columns, startPosition, endPosition) {
    const cells = new Set();
    if (!startPosition || !endPosition || !Array.isArray(rows) || !Array.isArray(columns)) {
        return cells;
    }

    const startRowIdx = Math.max(0, Math.min(startPosition.rowIdx, endPosition.rowIdx));
    const endRowIdx = Math.min(rows.length - 1, Math.max(startPosition.rowIdx, endPosition.rowIdx));
    const startColIdx = Math.max(0, Math.min(startPosition.colIdx, endPosition.colIdx));
    const endColIdx = Math.min(columns.length - 1, Math.max(startPosition.colIdx, endPosition.colIdx));

    for (let rowIdx = startRowIdx; rowIdx <= endRowIdx; rowIdx += 1) {
        const row = rows[rowIdx];
        for (let colIdx = startColIdx; colIdx <= endColIdx; colIdx += 1) {
            const cellKey = getCellKey(row, columns[colIdx]);
            if (cellKey) {
                cells.add(cellKey);
            }
        }
    }

    return cells;
}

export function getColumnCells(rows, column) {
    const cells = new Set();
    if (!isSelectableGridColumn(column)) {
        return cells;
    }

    rows.forEach((row) => {
        const cellKey = getCellKey(row, column);
        if (cellKey) {
            cells.add(cellKey);
        }
    });

    return cells;
}
